var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('chainEdit',{attrs:{"id":this.id},on:{"chain-update-complete":_vm.goBack,"chain-update-cancelled":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }